<template>
  <div
    ref="notificationModal"
    id="notificationModal"
    class="modal modal-v fade show"
    :data-backdrop="isDismissAble ? 'true':'static'"
    :data-keyboard="isDismissAble ? 'true':'false'"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <button v-if="isDismissAble" type="button" class="close atext-right mr-1" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body" v-if="notification.data">
          <h2 v-if="notification.data.title" class="title title--small mb-1 text-center">
            {{ notification.data.title }}
          </h2>
          <p v-if="notification.data.message" class="desc desc--lightgrey mb-1">
            {{ notification.data.message }}
          </p>
          <div v-if="notification.data.body" class="mb-1" v-html="notification.data.body">

          </div>

          <div v-if="isDismissAble">
            <div>
              <button @click="hide" class="btn btn-primary w-100">
                {{ trans.get('modal.close') }}
              </button>
            </div>
          </div>
          <div v-else>
            <form @submit.prevent="hide">
              <div class="form-check mb-2">
                <input v-model="approved" id="approve_check" type="checkbox" class="form-check-input" required>
                <label v-if="notification.data.approve_text" for="approve_check" class="form-check-label">
                  {{ notification.data.approve_text }}
                </label>
                <label v-else for="approve_check" class="form-check-label">
                  {{ trans.get('modal.approve') }}
                </label>
              </div>
              <button type="submit" class="btn btn-primary w-100">
                {{ trans.get('modal.close') }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationModal',
  props: {
    notification: Object,
  },
  data() {
    return {
      approved: false,
    };
  },
  computed: {
    isDismissAble: function () {
      return !!!this.notification.data.approve;
    },
  },
  watch: {},
  methods: {
    open() {
      $(this.$refs.notificationModal).modal('show');
    },
    hide() {
      $(this.$refs.notificationModal).modal('hide');
    },
    close() {
      this.$emit('close', this.notification);
    }
  },
  mounted() {
    let vm = this;

    this.$nextTick(() => {
      this.open();
    });

    $(this.$refs.notificationModal).on('hidden.bs.modal', function () {
      vm.close();
    });
  }
};
</script>

<style scoped>

</style>
